// frontend/src/pages/Home.jsx
import React, { useState } from "react";
import EstateEditorNew from "../components/EstateEditorNew";
import EstateEditor from "../components/EstateEditor";   // ✅ 누락 import

export default function Home({ content }) {
  // 🔥 신규등록 전용
  const [newEditorOpen, setNewEditorOpen] = useState(false);
  const [newEstate, setNewEstate] = useState(null);

  // 🔥 기존 수정 에디터
  const [editorOpen, setEditorOpen] = useState(false);
  const [selectedEstate, setSelectedEstate] = useState(null);

  /**
   * 신규 주소 선택 → PNU 생성 → 신규 에디터 오픈
   */
  const handleNewAddress = (addr) => {

    const estate = {
      estate_no: null,
      estate_id: null,
      pnu: null, // 🔥 아직 없음
      roadAddress: addr.roadAddress,
      jibunAddress: addr.jibunAddress,
      sigunguCd: addr.sigunguCd,
      bjdongCd: addr.bjdongCd,
      bun: addr.bun,
      ji: addr.ji,
      isMountain: addr.isMountain,
    };

    setNewEstate(estate);
    setNewEditorOpen(true);
  };

  return (
    <>
      {/* 기존 화면에 신규등록 콜백 주입 */}
      {React.cloneElement(content, {
        onNewAddress: handleNewAddress,
      })}

      {/* 🔵 신규등록 전용 에디터 */}
      <EstateEditorNew
        open={newEditorOpen}
        estate={newEstate}
        onClose={() => {
          setNewEditorOpen(false);
          setNewEstate(null);
        }}
        onSaved={(result) => {
          // result: { ok, estate_no, estate }
          setNewEditorOpen(false);
          setNewEstate(null);

          // 🔥 신규등록 완료 → 기존 수정 에디터로 전환
          setSelectedEstate({
            estate_no: result.estate_no,
            ...result.estate,
          });
          setEditorOpen(true);
        }}
      />

      {/* 🟢 기존 수정 에디터 */}
      {editorOpen && selectedEstate && (
        <EstateEditor
          open={editorOpen}
          mode="edit"
          estate={selectedEstate}
          onClose={() => setEditorOpen(false)}
          onSaved={() => {
            setEditorOpen(false);
            // 필요 시 리스트 reload
          }}
        />
      )}
    </>
  );
}
